
import RichText from '~/patterns/molecules/rich-text/rich-text';
import GwSection from '~/patterns/organisms/section/section';
import GwTextImage from '~/patterns/molecules/text-image/presets/text-image-cta.vue';
import GwCtaCard from '~/patterns/atoms/card/presets/cta-card.vue';
import ImageSingle from '~/patterns/atoms/image-single/image-single';
import GwButton from '~/patterns/atoms/button/button';
import GwIcon from '~/patterns/atoms/icon/icon';

export default {
    components: {
        RichText,
        GwSection,
        GwButton,
        GwIcon,
        ImageSingle,
        GwTextImage,
        GwCtaCard
    },

    props: {
        image: {
            type: Array,
            required: false,
            default: () => { return []; },
            // validator: imageObject => imageObject[0] && imageObject[0].w980
        },
        caption: {
            type: String,
            required: false,
            default: ''
        },
        heading: {
            type: String,
            required: false,
            default: ''
        },
        richText: {
            type: String,
            required: false,
            default: ''
        },
        imageAlignment: {
            type: String,
            required: false,
            default: 'left'
        },
        imageFit: {
            type: String,
            default: 'cover'
        },
        background: {
            type: String,
            required: false,
            default: 'primary'
        },
        label: {
            type: String,
            default: null
        },
        externalLink: {
            type: String,
            default: null
        },
        internalLink: {
            type: Array,
            default: () => { return []; }
        },
        asset: {
            type: Array,
            default: () => { return []; }
        },
    },

    computed: {
        hasImageOrText() {
            const hasImage = this.image && this.image[0] && this.image[0].w980;
            return hasImage || this.richText;
        },
        showButton() {
            return (this.externalLink || this.internalLink).length !== 0;
        }
    },
    methods: {
        isExternal() {
            return !this.internalLink.length;
        },
        url() {
            if (this.asset.length) {
                return this.asset[0].url;
            }

            return this.isExternal() ? this.externalLink : this.internalLink[0].url;
        }
    }
};
